export const BUILDING_CREATE_REQUEST = 'BUILDING_CREATE_REQUEST'
export const BUILDING_CREATE_SUCCESS = 'BUILDING_CREATE_SUCCESS'
export const BUILDING_CREATE_FAIL = 'BUILDING_CREATE_FAIL'
export const BUILDING_CREATE_RESET = 'BUILDING_CREATE_RESET'


export const LIST_BUILDING_REQUEST = 'LIST_BUILDING_REQUEST'
export const LIST_BUILDING_SUCCESS = 'LIST_BUILDING_SUCCESS'
export const LIST_BUILDING_FAIL = 'LIST_BUILDING_FAIL'
export const LIST_BUILDING_RESET = 'LIST_BUILDING_RESET'

export const BUILDING_DELETE_REQUEST = 'BUILDING_DELETE_REQUEST'
export const BUILDING_DELETE_SUCCESS = 'BUILDING_DELETE_SUCCESS'
export const BUILDING_DELETE_FAIL = 'BUILDING_DELETE_FAIL'

export const BUILDING_UPDATE_REQUEST = 'BUILDING_UPDATE_REQUEST'
export const BUILDING_UPDATE_SUCCESS = 'BUILDING_UPDATE_SUCCESS'
export const BUILDING_UPDATE_FAIL = 'BUILDING_UPDATE_FAIL'
export const BUILDING_UPDATE_RESET = 'BUILDING_UPDATE_RESET'


export const BUILDING_DETAILS_REQUEST = 'BUILDING_DETAILS_REQUEST'
export const BUILDING_DETAILS_SUCCESS = 'BUILDING_DETAILS_SUCCESS'
export const BUILDING_DETAILS_FAIL = 'BUILDING_DETAILS_FAIL'